/* global L */

/**
 * @param {Object} config
 * @param {string} config.lat
 * @param {string} config.lon
 * @param {string} config.zoom
 * @param {string|null} config.shopId
 * @param {string|null} config.destinationId
 * @param {string} config.tileUrl
 * @param {string} config.labelBook
 * @param {Array}  config.points
 */
window.initMapBox = function (config) {
    var image    = '/images/map_ping.svg';
    var imageBw  = '/images/map_ping_bw.svg';
    var markers  = [];

    var dragging = !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

    var map = L.map('mapBox', { dragging: dragging }).setView([config.lat, config.lon], config.zoom);
    map.scrollWheelZoom.disable();
    L.tileLayer(config.tileUrl, {}).addTo(map);

    if (!config.shopId && !config.destinationId) {
        map.on('zoomend', setIcon);
    }

    function setIcon() {
        var currentZoom = map.getZoom();
        markers.forEach(function (marker) {
            var icon = L.icon({ iconUrl: image, iconSize: [52, 52], iconAnchor: [25, 52], popupAnchor: [0, -52] });
            if (currentZoom < 12) {
                icon = L.divIcon({ className: 'icon-map' });
            }
            marker.setIcon(icon);
        });
    }

    function addMarker(lat, lng, title, content, url, disabled, showBtn) {
        var currentZoom = map.getZoom();
        var popup = showBtn
            ? '<div id="infoWindowBox"><h3 class="page_title"><a href="' + url + '" target="_top">' + title + '</a></h3><p>' + content + '</p><span class="btn_default">' + config.labelBook + '</span><a href="' + url + '" target="_top" class="linkdef"></a></div>'
            : '<div id="infoWindowBox"><h3 class="page_title"><b>' + title + '</b></h3><p>' + content + '</p></div>';

        var icon = L.icon({ iconUrl: (disabled ? imageBw : image), iconSize: [52, 52], iconAnchor: [25, 52], popupAnchor: [0, -52] });
        if (currentZoom < 12) {
            icon = L.divIcon({ className: 'icon-map' });
        }
        var marker = L.marker([lat, lng], { icon: icon }).addTo(map).bindPopup(popup);
        markers.push(marker);
    }

    map.whenReady(function () {
        config.points.forEach(function (point) {
            addMarker(point.lat, point.lon, point.title, point.content, point.url, point.disabled, point.show_btn);
        });
    });
};
